export default "__VITE_ASSET__84146d5f__"